import { GmrFunctionParameter } from '../core/gmr.models';

//
// The one definition of "this parameter still needs a value", shared by the component that owns the
// submit (ParameterFormComponent) and the one that has to report it on a widget the browser cannot
// validate by itself (LovSelectComponent). Deliberately a plain function rather than a method on a
// service: it is a rule about a single parameter object, with no state and nothing to inject.
//
// Mirrors ParameterFieldComponent's isRequired rule - required flag, checkbox exempt - with one
// deliberate exception: the divisions multi-select is checked unconditionally, NOT gated on
// cfr_required_flag. Downloading with an empty companies dropdown must never be possible; that is a
// business rule, not something the backend's required flag should be able to opt out of. The app
// already special-cases this one LOV preset elsewhere (LovSelectComponent.isMulti, GmrDataService's
// selectAllDivisions/selectDefaultDivisions).
//
export const DIVISIONS_MULTI_LOV_PRESET = 'gmr-eol-lov-divisions-multi';

export function isParameterMissing(parameter: GmrFunctionParameter): boolean
{
  if (parameter.data_ind_html_control === 'checkbox')
  {
    return false;
  }

  if (parameter.cfr_lov_preset === DIVISIONS_MULTI_LOV_PRESET)
  {
    return (parameter.cfr_default_value_arr?.length ?? 0) === 0;
  }

  if (parameter.cfr_required_flag !== true)
  {
    return false;
  }

  return parameter.cfr_default_value == null || parameter.cfr_default_value === '';
}
